import React from 'react'

export const Todositem = ({todo , onDelete}) => {
    let divStyle = {
        borderBottom: '2px solid black',
    }
    return (
        <div className='text-start'style={divStyle}>
            <h4 className='text-start'>{todo.title}</h4>
            <p className='text-start'>{todo.desc}</p>
            <button className="btn btn-sm btn-danger mb-3 border border-dark border-2" onClick={()=>{onDelete(todo)}}>Delete</button> 
        </div>
    )
}
